const PageMenu = {
  홈: '홈',
  포트폴리오: '포트폴리오',
  // 숏콘: '숏콘',
} as const;

type PageMenu = typeof PageMenu[keyof typeof PageMenu];

export default PageMenu;